import { render, staticRenderFns } from "./ReportedWallpapers.vue?vue&type=template&id=9cd02b38&scoped=true"
import script from "./ReportedWallpapers.vue?vue&type=script&lang=js"
export * from "./ReportedWallpapers.vue?vue&type=script&lang=js"
import style0 from "./ReportedWallpapers.vue?vue&type=style&index=0&id=9cd02b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd02b38",
  null
  
)

export default component.exports